import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import './LandingSections.css';

const FeaturedBlogs = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            const res = await axios.get(`${config.API_URL}/blogs`);
            setBlogs(res.data.slice(0, 3)); // Get only 3 latest
            setLoading(false);
        } catch (error) {
            console.error('Error fetching blogs:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return <div>Loading blogs...</div>;
    }

    return (
        <section className="featured-section featured-blogs">
            <div className="container">
                <h2>Latest from Our Blog</h2>
                <p className="section-subtitle">Stay updated with chess tips, strategies, and news</p>

                <div className="featured-grid">
                    {blogs.map(blog => (
                        <div key={blog.id} className="featured-card">
                            <div className="featured-content">
                                <h3>{blog.title}</h3>
                                {blog.excerpt && (
                                    <p className="blog-excerpt">{blog.excerpt}</p>
                                )}
                                <p className="blog-meta">
                                    By {blog.author.username} • {new Date(blog.createdAt).toLocaleDateString()}
                                </p>
                                <Link to={`/post/${blog.slug}`} className="btn-read-more">
                                    Read More →
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="view-all-container">
                    <Link to="/blog" className="btn-view-all">View All Posts</Link>
                </div>
            </div>
        </section>
    );
};

export default FeaturedBlogs;
